import Vue from 'vue'
import VueRouter from 'vue-router'
import Profile from '../helpers/profile'

import ErrorPage from '../pages/errorPage.vue'
import LoginWelcome from '../pages/login/welcomPage.vue'
import LoginEnterLogin from '../pages/login/enterLoginPage.vue'
import LoginSendCode from '../pages/login/sendCodePage.vue'
import LoginSendCodeForRegistration from '../pages/login/sendCodeForRegistrationPage.vue'
import LoginEnterCode from '../pages/login/enterCodePage.vue'
import LoginEnterPinCode from '../pages/login/enterPinCodePage.vue'
import LoginEnterSecretQuestion from '../pages/login/enterSecretQuestionPage.vue'
import InfoSetAdditionalParams from '../pages/login/infoSetAdditionalParams.vue'

import RegistrationStart from '../pages/registration/infoRegistrationPage.vue'
import RegistrationCancel from '../pages/registration/cancelRegistrationPage.vue'
import RegistrationLastName from '../pages/registration/fio/setLastName.vue'
import RegistrationFirstName from '../pages/registration/fio/setFirstName.vue'
import RegistrationMiddleName from '../pages/registration/fio/setMiddleName.vue'
import RegistrationFio from '../pages/registration/fio/setFioPage.vue'
import RegistrationStartBirthday from '../pages/registration/infoSetBirthdayPage.vue'
import RegistrationSetBirthday from '../pages/registration/setBirthdayPage.vue'
import RegistrationUserAlreadyExist from '../pages/registration/userAlreadyExistPage.vue'
import RegistrationInfoPinCodePage  from '../pages/registration/pincode/infoSetPinCodePage.vue'
import RegistrationSetPinCodeAll  from '../pages/registration/pincode/setAllPinCodePage.vue'
import RegistrationSetPinCode  from '../pages/registration/pincode/setPinCodePage.vue'
import RegistrationInfoSecretQuestion  from '../pages/registration/infoSecretQuestionPage.vue'
import RegistrationSetSecretQuestion  from '../pages/registration/setSecretQuestionPage.vue'
import RegistrationSetPromptSecretQuestion  from '../pages/registration/setPromptSecretQustionPage.vue'
import RegistrationFinish  from '../pages/registration/finishRegistrationPage.vue'
import EnterPhoneEmail  from '../pages/registration/enterPhoneEmailPage.vue'

import AccessRecoveryStart  from '../pages/accessRecovery/infoAccessRecoveryPage.vue'
import AccessRecoverySetPhone  from '../pages/accessRecovery/setPhonePage.vue'
import AccessRecoverySetEmail  from '../pages/accessRecovery/setEmailPage.vue'
import AccessRecoveryInfoSelectLogin  from '../pages/accessRecovery/infoSelectLoginPage.vue'
import AccessRecoveryInfoSelectLoginError  from '../pages/accessRecovery/infoSelectLoginErrorPage.vue'
import AccessRecoverySelectLogin  from '../pages/accessRecovery/selectLoginPage.vue'



Vue.use(VueRouter);

  const routes = [
    { path: '/errorPage/:id', name: 'ErrorPage', component: ErrorPage },
    { path: '*', name: 'ErrorPage404', component: ErrorPage },

    { path: '/login/', name: 'LoginWelcome', component: LoginWelcome },
    { path: '/login/enterLogin', name: 'LoginEnterLogin', component: LoginEnterLogin },
    { path: '/login/sendCode', alias: ['/login/enterSecondCode', '/registration/sendCode'], name: 'LoginSendCode', component: LoginSendCode },
    { path: '/login/sendCodeForRegistration', name: 'LoginSendCodeForRegistration', component: LoginSendCodeForRegistration },
    { path: '/login/enterCode', name: 'LoginEnterCode', component: LoginEnterCode },
    { path: '/login/infoSetAdditionalParams', alias: ['/accessRecovery/infoSetAdditionalParams'], name: 'infoSetAdditionalParams', component: InfoSetAdditionalParams },
    { path: '/login/enterPinCode', name: 'LoginEnterPinCode', component: LoginEnterPinCode },
    { path: '/login/enterSecretQuestion', name: 'LoginEnterSecretQuestion', component: LoginEnterSecretQuestion },

    { path: '/registration', name: 'RegistrationStart', component: RegistrationStart },
    { path: '/registration/cancel', name: 'RegistrationCancel', component: RegistrationCancel },
    { path: '/registration/setLastName', name: 'RegistrationLastName', component: RegistrationLastName },
    { path: '/registration/setFirstName', name: 'RegistrationFirstName', component: RegistrationFirstName },
    { path: '/registration/setMiddleName', name: 'RegistrationMiddleName', component: RegistrationMiddleName },
    { path: '/registration/setFio', name: 'RegistrationFio', component: RegistrationFio },
    { path: '/registration/startBirthday', name: 'RegistrationStartBirthday', component: RegistrationStartBirthday },
    { path: '/registration/setBirthday', name: 'RegistrationSetBirthday', component: RegistrationSetBirthday },
    { path: '/registration/userAlreadyExist', name: 'RegistrationUserAlreadyExist', component: RegistrationUserAlreadyExist },
    { path: '/registration/enterPhonePage',
        alias: [
            '/login/enterPhonePage',
            '/registration/enterEmailPage',
            '/accessRecovery/enterPhonePage',
            '/accessRecovery/enterEmailPage'
        ], name: 'enterPhoneEmailPage', component: EnterPhoneEmail },

    { path: '/registration/infoPinCode',
        alias: ['/login/infoPinCode', '/accessRecovery/infoPinCode'],
        name: 'RegistrationInfoPinCodePage', component: RegistrationInfoPinCodePage },
    { path: '/registration/setPinCodeAll',
        alias: ['/login/setPinCodeAll','/accessRecovery/setPinCodeAll'],
        name: 'RegistrationSetPinCodeAll', component: RegistrationSetPinCodeAll },
    { path: '/registration/setPinCode',
        alias: ['/login/setPinCode','/accessRecovery/setPinCode'],
        name: 'RegistrationSetPinCode', component: RegistrationSetPinCode },

    { path: '/registration/infoSecretQuestion',
        alias: ['/login/infoSecretQuestion', '/accessRecovery/infoSecretQuestion'],
        name: 'RegistrationInfoSecretQuestion', component: RegistrationInfoSecretQuestion },
    { path: '/registration/setSecretQuestion',
        alias: ['/login/setSecretQuestion', '/accessRecovery/setSecretQuestion'],
        name: 'RegistrationSetSecretQuestion', component: RegistrationSetSecretQuestion },
    { path: '/registration/setPromptSecretQuestion',
        alias: ['/login/setPromptSecretQuestion', '/accessRecovery/setPromptSecretQuestion'],
        name: 'RegistrationSetPromptSecretQuestion', component: RegistrationSetPromptSecretQuestion },

      { path: '/registration/finish', name: 'RegistrationFinish', component: RegistrationFinish },

    // { path: '/', name: 'AccessRecoveryStart', component: AccessRecoveryStart },
    { path: '/accessRecovery/', name: 'AccessRecoveryStart', component: AccessRecoveryStart },
    { path: '/accessRecovery/setPhone', name: 'AccessRecoverySetPhone', component: AccessRecoverySetPhone },
    { path: '/accessRecovery/setEmail', name: 'AccessRecoverySetEmail', component: AccessRecoverySetEmail },
      { path: '/accessRecovery/setLastName', name: 'AccessRecoveryLastName', component: RegistrationLastName },
      { path: '/accessRecovery/setFirstName', name: 'AccessRecoveryFirstName', component: RegistrationFirstName },
      { path: '/accessRecovery/setMiddleName', name: 'AccessRecoveryMiddleName', component: RegistrationMiddleName },
      { path: '/accessRecovery/setFio', name: 'AccessRecoveryFio', component: RegistrationFio },
      { path: '/accessRecovery/startBirthday', name: 'AccessRecoveryStartBirthday', component: RegistrationStartBirthday },
      { path: '/accessRecovery/setBirthday', name: 'AccessRecoverySetBirthday', component: RegistrationSetBirthday },
    { path: '/accessRecovery/infoSelectLogin', name: 'AccessRecoveryInfoSelectLogin', component: AccessRecoveryInfoSelectLogin },
    { path: '/accessRecovery/infoSelectLoginError', name: 'AccessRecoveryInfoSelectLoginError', component: AccessRecoveryInfoSelectLoginError },
    { path: '/accessRecovery/selectLogin', name: 'AccessRecoverySelectLogin', component: AccessRecoverySelectLogin },
      { path: '/accessRecovery/sendCode', alias: ['/accessRecovery/sendSecondCode', '/accessRecovery/sendThirdCode'], name: 'AccessRecoverySendCode', component: LoginSendCode },
      { path: '/accessRecovery/enterCode', alias: ['/accessRecovery/enterSecondCode', '/accessRecovery/enterThirdCode'], name: 'AccessRecoveryEnterCode', component: LoginEnterCode },
      { path: '/accessRecovery/finish', name: 'AccessRecoveryFinish', component: RegistrationFinish },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
    // if (!to.query.login_challenge && !Profile.challenge && to.name !== 'ErrorPage') {
    //     next({
    //         name: 'ErrorPage',
    //         params: {id : '410'}
    //     });
    // } else
        next()
})

export default router
